module.exports = __webpack_public_path__ + "static/Sample-2-84b8e7296e7d82f9dfa082fac503a508.png";